<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-check"
          plain
          v-if="permissionList.syncBtn"
          @click="syncButton"
        >同 步
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-check"
          v-if="permission.carplatematchrule_add"
          :hidden="hideStopButton(scope.row)"
          @click="stopButton(scope.row)">
          停用
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-check"
          v-if="permission.carplatematchrule_add"
          :hidden="hideStartButton(scope.row)"
          @click="startButton(scope.row)">

          启用
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update, sync,updateStatus,getCarParkList} from "@/api/v4ward/car/carplatematchrule";
    import {mapGetters} from "vuex";

    export default {
      data: function () {
        return {
          form: {},
          query: {},
          loading: true,
          reWrite: false,
          firstDisplayFlag:false,
          tempCarParkId: '',
          carParkList: [],
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 50,
            tip: false,
            border: true,
            indexLabel:'序号',
            index: true,
            viewBtn: true,
            selection: true,
            columnBtn: false,
            refreshBtn: false,
            delBtn:false,
            searchMenuSpan: 6,
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
                width: 120,
              },
              {
                label: "车场名称",
                prop: "parkingLotId",
                type: 'tree',
                searchClearable:false,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                search: true,
                width: 120,
                dicUrl: '/api/v4ward/car/ParkSpace/getCarParkList',
                props: { label: 'spaceName', value: 'id' },
                rules: [{
                  required: true,
                  message: "请选择车场名称",
                  trigger: "blur"
                }]
              },
              {
                label: "车场名称",
                prop: "parkingLotIds",
                hide: true,
                type: 'tree',
                editDisabled: true,
                multiple:true,
                span: 24,
                width: 120,
                dicUrl: '/api/v4ward/car/ParkSpace/getCarParkList',
                props: { label: 'spaceName', value: 'id' },
                rules: [
                  {required: true,
                  message: "请选择车场名称",
                  trigger: "blur"
                }]
              },
              {
                label: "匹配方式",
                prop: "matchType",
                type: 'select',
                dataType: 'number',
                span: 24,
                width: 90,
                dicUrl: 'api/blade-system/dict/dictionary?code=match_type',
                props: { label: 'dictValue', value: 'dictKey' },
                rules: [{
                  required: true,
                  message: "请选择匹配方式",
                  trigger: "blur"
                }]
              },
              {
                label: "车牌字母",
                prop: "numberFrom",
                search: true,
                display: false,
                span: 24,
                width: 90,
                rules: [
                  {
                    pattern: this.$validation.carPlate,
                    message: '车牌号格式错误'
                  },
                  {
                  required: true,
                  message: "请输入识别到的车牌字母",
                  trigger: "blur"
                }]
              },
              {
                label: "车牌字母",
                prop: "numberFromOne",
                display: false,
                hide: true,
                span: 24,
                width: 90,
                rules: [
                  {
                    pattern: this.$validation.carPlate,
                    message: '请输入单个字符，且车牌中允许出现的字符！'
                  },
                  {
                    required: true,
                    message: "请输入车牌字母",
                    trigger: "blur"
                  }]
              },
              {
                label: "匹配字母",
                prop: "numberTo",
                display: false,
                span: 24,
                width: 90,
                rules: [
                  { pattern: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]{1}([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}))$/, message: '车牌号格式错误' },
                  {
                  required: true,
                  message: "请输入匹配的字母",
                  trigger: "blur"
                }]
              },
              {
                label: "匹配字母",
                prop: "numberToOne",
                display: false,
                hide: true,
                span: 24,
                width: 90,
                rules: [
                  { pattern: /^(([A-H,J-N,P-Z])||([0-9])||(京||津||沪||渝||冀||豫||云||辽||黑||湘||皖||鲁||新||苏||浙||赣||鄂||桂||甘||晋||蒙||陕||吉||闽||贵||粤||青||藏||川||宁||琼||使||领)){1}$/g, message: '请输入单个字符，且车牌中允许出现的字符！' },
                  {
                    required: true,
                    message: "请输入尝试匹配的字母",
                    trigger: "blur"
                  }]
              },
              {
                label: '状态',
                prop: 'status',
                type: 'select',
                dataType: 'number',
                dicUrl: 'api/blade-system/dict/dictionary?code=switch',
                props: { label: 'dictValue', value: 'dictKey' },
                editDisplay: false,
                addDisplay: false,
                width: 100,
              },
              {
                label: "备注信息",
                prop: "remark",
                type: 'textarea',
                span: 24,
                row: 4,
                maxlength: 100,
                showWordLimit: true,
                overHidden: true,
              },
            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.carplatematchrule_add, false),
                    viewBtn: this.vaildData(this.permission.carplatematchrule_view, false),
                    delBtn: this.vaildData(this.permission.carplatematchrule_delete, false),
                    editBtn: this.vaildData(this.permission.carplatematchrule_edit, false),
                    syncBtn: this.vaildData(this.permission.carplatematchrule_sync, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      watch: {
        'form.matchType'() {
          if (this.form.matchType === 1) {
            this.findObject(
              this.option.column,
              'numberFrom'
            ).display = true;
            this.findObject(
              this.option.column,
              'numberTo'
            ).display = true;

            this.findObject(
              this.option.column,
              'numberFromOne'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberToOne'
            ).display = false;
          }
          if (this.form.matchType === 2) {
            this.findObject(
              this.option.column,
              'numberFrom'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberTo'
            ).display = false;

            this.findObject(
              this.option.column,
              'numberFromOne'
            ).display = true;
            this.findObject(
              this.option.column,
              'numberToOne'
            ).display = true;
          }
        },
      },
      created() {
        //加载列表
        getCarParkList({}).then((res) => {
          this.carParkList = res.data;
          if (this.carParkList.length > 0) {
            this.query.parkingLotId = this.carParkList[0].id;
            this.tempCarParkId = this.carParkList[0].id;
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });
          //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
          this.firstDisplayFlag = true;
        });
      },
      methods: {
        getCarParkNameById(carParkId) {
          let carParkName = '';
          this.carParkList.forEach(function (value, index, array) {
            if (value.id === carParkId) {
              carParkName = value.spaceName;
              return;
            }
          });
          return carParkName;
        },
        stopButton(row){
          updateStatus({id:row.id,status:0}).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              console.log(error);
            }
          );
        },
        startButton(row){
          updateStatus({id:row.id,status:1}).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              console.log(error);
            }
          );
        },
        hideStartButton(row){
          return row.status === 1;
        },
        hideStopButton(row){
          return row.status === 0;
        },
        rowSave(row, loading, done) {
          if (row.matchType === 2) {
            row.numberFrom = row.numberFromOne;
            row.numberTo = row.numberToOne;
          }
          if(row.numberFrom===row.numberTo){
            this.$message.error('车牌字母与匹配字母重复!');
            done();
            return;
          }
          row.parkingLotIds = row.parkingLotIds.join(",");
          add(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowUpdate(row, index, loading, done) {
          if (row.matchType === 2) {
            row.numberFrom = row.numberFromOne;
            row.numberTo = row.numberToOne;
          }
          if(row.numberFrom===row.numberTo){
            this.$message.error('车牌字母与匹配字母重复!');
            done();
            return;
          }
          //row.parkingLotId = row.parkingLotIds.join(",");
          row.parkingLotIds = '';
          update(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowDel(row) {
          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ ids: row.id });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
            });
        },
        syncButton() {
          if (this.selectionList.length === 0) {
            this.$message.warning('请选择至少一条数据');
            return;
          }
          this.$confirm('确定将选择数据同步?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return sync({ ids: this.ids });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
        },
        beforeOpen(done, type) {
          if (['edit', 'view'].includes(type)) {
            getDetail({ id: this.form.id }).then(({ data }) => {
              this.form = data;
              this.form.parkingLotIds = data.parkingLotId;
              if (data.matchType === 2) {
                this.form.numberFromOne = data.numberFrom;
                this.form.numberToOne = data.numberTo;
              }
            });
          }else {
            this.findObject(
              this.option.column,
              'numberFrom'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberTo'
            ).display = false;

            this.findObject(
              this.option.column,
              'numberFromOne'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberToOne'
            ).display = false;
          }
          done();
        },
        searchReset() {
          this.query.numberFrom = '';
          this.firstDisplayFlag = true;
          this.onLoad();
        },
        searchChange(params, done) {
          this.query = params;
          this.page.currentPage = 1;
          done();
          this.onLoad();
        },
        selectionChange(list) {
          this.selectionList = list;
        },
        selectionClear() {
          this.selectionList = [];
          this.$refs.crud.toggleSelection();
        },
        currentChange(currentPage) {
          this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
          this.page.pageSize = pageSize;
        },
        onLoad(page) {
          page = page || this.page;
          this.loading = true;
          //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
          if (!this.query.parkingLotId ) {
            this.query.parkingLotId = this.tempCarParkId;
          }
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.getCarParkNameById(this.query.parkingLotId);
              this.tempCarParkId = this.query.parkingLotId;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          });
        }
      },
    };
</script>

<style>
</style>
